import Vue from 'vue'
import Router from 'vue-router'
// 官网路由配置
import zaiartRoutes from './zaiart'
// 后台路由配置
import adminRoutes from './admin'

Vue.use(Router)

export default new Router({
  // mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes: zaiartRoutes.concat(adminRoutes)
})
